import "./index.css";
import { useState, useEffect } from "react";
import { Select, notification } from "antd";
import { useAuth } from "../../context/auth";

const ChargerBrandDropdown = ({ setSelectedChargerBrands, ...props }) => {
  const { accessToken } = useAuth();

  const [chargerBrands, setChargerBrands] = useState([]);
  useEffect(() => {
    async function getChargerBrands() {
      const url = new URL('/api/charger-brand', window.location);
      url.searchParams.append('mode', 'dropdown');

      const res = await fetch(url, {
        headers: { 'X-ACCESS-TOKEN': accessToken },
      });
      if (res.ok) {
        const { chargerBrands } = await res.json();
        setChargerBrands(chargerBrands);
      } else {
        notification["error"]({
          message: "Something went wrong !",
          description: `Please re-login or contact web admin. (Code: ${await res.json().then(data => data.message)})`,
        });
      }
    }

    getChargerBrands();
  }, [accessToken]);

  return (
    <Select
      {...props}
      showSearch
      placeholder="Charger Brand Name"
      maxTagCount="responsive"
      maxTagPlaceholder={(ids) => `+ ${ids.length}`}
      optionFilterProp="children"
    >
      {setSelectedChargerBrands && (
        <div disabled={true}>
          <span
            onClick={() => setSelectedChargerBrands(chargerBrands.map(chargerBrand => chargerBrand.id))}
            style={{
              display: "inline-block",
              color: "#286FBE",
              cursor: "pointer",
            }}
          >
            SELECT ALL
          </span>
        </div>
      )}
      {chargerBrands.map(chargerBrand => (
        <Select.Option key={chargerBrand.id} value={chargerBrand.id}>
          {chargerBrand.name} (Min Power {chargerBrand.minPowerKw} kW)
        </Select.Option>
      ))}
    </Select>
  );
};

export default ChargerBrandDropdown;
